<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>


    <div v-if="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item flexible">
                <label class="label-caption" for="nmPesquisa">Nome Pesquisa</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="80" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="showModalCpfCnpj=true" />
            <button type="button" class="buttom-icon--close" @click="closePage" />
        </div>

        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th class="col-width-integer">Código</th>
                        <th>Nome</th>
                        <th class="col-width-char30">Localidade</th>
                        <th class="col-width-doc">CPF/CNPJ</th>
                        <th class="col-width-doc">Fone</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" @click="editarCadastro(obj)">
                        <td class="col-width-integer right">{{ obj.cdpessoa }}</td>
                        <td>{{ obj.nmpessoa }}</td>
                        <td class="col-width-char30">{{ obj.nmlocalidade }}</td>
                        <td class="col-width-doc center">{{ obj.cpfcnpj }}</td>
                        <td class="col-width-doc center">{{ obj.fone }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>

    <CpfCnpjModal
        v-if="showModalCpfCnpj"
        @close="showModalCpfCnpj = false"
        @cpfCnpjSubmitted="novoCadastro"
    />

    <div v-if="modoEdicao">
        <PessoaEditPage :idEdicao="idEdicao" :cpfCnpjNovo="cpfCnpjNovo" @close="modoEdicao = false" @salvo="lerDados" />
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import CpfCnpjModal from '@/components/modals/CpfCnpjModal.vue';
import PessoaEditPage from '../formularios/PessoaEditPage.vue';

const emit = defineEmits(['close']);

const cpfCnpjNovo = ref(null);
const idEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const nmPesquisa = ref('');

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showModalCpfCnpj = ref(false);
const showPagination = ref(false);

const closePage = () =>{emit('close');};

const editarCadastro = (obj) => {
    idEdicao.value = obj.id;
    modoEdicao.value = true;
};

const lerDados = async() => {
    try{
        isLoading.value = true;
        const dados = {
            idmunicipio: globalStore.idmunicipio, 
            nmpesquisar: nmPesquisa.value};
        const req = await Api.genericPost('/listas/pessoas', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){console.error('Erro leitura dos dados', error);
    } finally {isLoading.value = false;}
}

const novoCadastro = async(value) => {
    showModalCpfCnpj.value=false;
    if (!value) return;
    try{
        isLoading.value=true;
        const req = await Api.genericGet('/cad/pessoa/from_cpfcnpj', {
            idmunicipio: globalStore.idmunicipio,
            idusuario: globalStore.idusuario,
            cpfcnpj: value});
        if (req.length===0){idEdicao.value=0; cpfCnpjNovo.value=value;}else{idEdicao.value=req[0].id}
    } catch (error){console.error('Erro leitura dos dados', error);
    } finally {isLoading.value = false;}
    modoEdicao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}
</script>
